import { useSearchParams } from 'react-router-dom';

import { parseCommaSeparatedParam } from './useDiscoverabilitySearchParams';

export type ScanScopeParams = {
  dateTimeFrom: string | undefined;
  dateTimeTo: string | undefined;
  domains: string[] | undefined;
};

/**
 * Reads the scan-scope URL parameters that pin the Pages to Review table to the
 * exact population the daily Discoverability scan counted: the absolute
 * datetime window (`dateTimeFrom`/`dateTimeTo`, opaque ISO strings forwarded
 * as-is) and the comma-separated evaluable `domains` list (fanned out to
 * repeated `domains` query params at the API boundary).
 *
 * Kept separate from `useDiscoverabilitySearchParams` on purpose: KPIs and
 * charts consume that shared hook and must ignore the scan window entirely, so
 * only `PagesToReviewSection` reads these params.
 */
export function useScanScopeParams(): ScanScopeParams {
  const [searchParams] = useSearchParams();

  const dateTimeFrom = searchParams.get('dateTimeFrom');
  const dateTimeTo = searchParams.get('dateTimeTo');
  const domains = searchParams.get('domains');

  return {
    dateTimeFrom: dateTimeFrom !== null ? dateTimeFrom : undefined,
    dateTimeTo: dateTimeTo !== null ? dateTimeTo : undefined,
    domains: domains !== null ? parseCommaSeparatedParam(domains) : undefined,
  };
}
